import React from 'react';
import PropTypes from 'prop-types';
import MainGridTopLeftDayOn from './MainGridTopLeftDayOn';
import MainGridTopRightDayOffTypeSlot from './MainGridTopRightDayOffTypeSlot';
import MainGridMiddleLeftDayOnTypeSlot from './MainGridMiddleLeftDayOnTypeSlot';
import MainGridMiddleRightDayOnTypeSlot from './MainGridMiddleRightDayOnTypeSlot';

/**
 * MainGrid4
 */
class MainGrid4 extends React.Component {

  componentDidMount() {
    $('#ledger_sheet_01').flexLedgerSheet();
    $('#ledger_sheet_01').bindClickTriggerContextMenu();
  }

  componentDidUpdate() {
    if (this.props.data.offset != 1 && this.props.data.scrollEnd == false) {
      $('#ledger_sheet_01').flexLedgerSheetScrollDown();
      $('#ledger_sheet_01').bindClickTriggerContextMenu();
    }
  }

  render() {
    const pskubun = this.props.data.pskubun;
    const kikanUnit = this.props.data.kikanUnit;
    const term = this.props.data.term;
    const toK015Param = {
      pskubun: pskubun,
      kikanUnit: kikanUnit,
      term: term
    }
    return (
      <div id="ledger_sheet_01" className="wrap_ledger_sheet limit_col_width grid4">
        <div className="ledger_sheet_top grid_sheet_top">
          <MainGridTopLeftDayOn />
          <MainGridTopRightDayOffTypeSlot actions={this.props.actions} sortKey={this.props.data.sortKey} sortOrder={this.props.data.sortOrder} dayFlg={this.props.data.dayFlg} usedMachinePriceDataUpdateFlag={this.props.data.usedMachinePriceDataUpdateFlag} />
        </div>
        <div className="ledger_sheet_middle grid_line_bottom">
          <MainGridMiddleLeftDayOnTypeSlot dataDayOn={this.props.data.dataSlotDayOn} toK015Param={toK015Param} actions={this.props.actions} />
          <MainGridMiddleRightDayOnTypeSlot dataDayOn={this.props.data.dataSlotDayOn} actions={this.props.actions} />
        </div>
      </div>
    );
  }
}

MainGrid4.propTypes = {
  data: PropTypes.any.isRequired,
  actions: PropTypes.any.isRequired
};

export default MainGrid4;
